import KT01BaseLayout from "general/components/BaseLayout/KT01BaseLayout";
import { Route, Routes } from "react-router-dom";
import GroupReconciliationListScreen from "./screens/GroupReconciliationListScreen";
import GroupReconciliationDetailScreen from "./screens/GroupReconciliationDetailScreen";

function GroupReconciliationReport(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0 pb-4">
                <Routes>
                    <Route
                        path=""
                        element={
                            <GroupReconciliationListScreen />
                        }
                    />
                    <Route
                        path="/:reconciliationId"
                        element={<GroupReconciliationDetailScreen />}
                    />
                    <Route path="*" element={<>Not found</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default GroupReconciliationReport;
